'use client';

import React from 'react';
import { PortableTextBlock } from 'next-sanity';

import AccordionComponent from '@/componentv2/accordion/accordion';
import type { AccordionItem } from '@/componentv2/accordion/accordion';
import Typography from '@/componentv2/typography/typography';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';

import './faqAccordion.scss';

export type FaqAnswerBlocks = PortableTextBlock[];

export type FaqAccordionItem = {
  question: string;
  answer?: string;
  answerBlocks?: FaqAnswerBlocks;
};

type FaqAccordionProps = {
  header: string;
  items: FaqAccordionItem[];
  defaultOpenIndex?: number | null;
};

export default function FaqAccordion({
  header,
  items,
  defaultOpenIndex = 0,
}: FaqAccordionProps) {
  if (!items.length) {
    return null;
  }

  const accordionItems: AccordionItem[] = items.map((item, index) => ({
    id: index.toString(),
    title: item.question,
    content: item.answerBlocks?.length ? (
      <LandingPortableText
        paragraphStyle="paragraph-small-1"
        value={item.answerBlocks}
      />
    ) : item.answer ? (
      <Typography style="paragraph-small-1">{item.answer}</Typography>
    ) : null,
  }));

  const defaultActiveKey =
    defaultOpenIndex === null || defaultOpenIndex === undefined
      ? undefined
      : String(defaultOpenIndex);

  return (
    <section className="faq-accordion">
      <div className="container">
        {header ? (
          <Typography as="h2" style="eyebrow-badge">
            {header}
          </Typography>
        ) : null}
        <AccordionComponent
          items={accordionItems}
          defaultActiveKey={defaultActiveKey}
          flush={true}
        />
      </div>
    </section>
  );
}
